import App from './App.svelte';

const app = new App({
	target: document.body,
	props: {
		name: 'Ein Prosit auf den besonderen Moment'
	}
});

export default app;